import { useState } from "react";

import { SortableDropdownOpenStateType } from "@/components/@types";
import { List } from "@/components/organisms/List";
import { SortChipControls } from "@/components/organisms/UtilityBar/SortChip/SortChipControls";
import { SortChipDefinitionRow } from "@/components/organisms/UtilityBar/SortChip/SortChipDefinitionRow";
import { useSortChipState } from "@/components/organisms/UtilityBar/FilterChip/FilterChipStateContext";

export function SortChipContent({
  isOpenState,
}: {
  isOpenState: [boolean, (isOpen: boolean) => void];
}) {
  const [, setIsOpen] = isOpenState;
  const { sortables, sortableDefinitions, setSortables } = useSortChipState();

  const [dropdownOpenIndexes, setDropdownOpenIndexes] = useState<
    SortableDropdownOpenStateType[]
  >([]);

  if (sortables.length === 0) {
    return (
      <List
        data={Object.keys(sortableDefinitions).map((key) => ({
          key,
          ...sortableDefinitions[key],
        }))}
        onItemClick={(sortableDefinition) => {
          // setIsNameOpen(false);
          // first grouping for the sortable
          const operator = sortableDefinition?.operators?.[0];
          setSortables([{ ...sortableDefinition, value: operator.key }]);
        }}
      >
        <List.Items>
          {(sortableDefinition: any) => (
            <List.Item
              value={sortableDefinition}
              data-testid={`sort-definition-option-${sortableDefinition.name}`}
            >
              <SortChipDefinitionRow sortableDefinition={sortableDefinition} />
            </List.Item>
          )}
        </List.Items>
      </List>
    );
  }

  return (
    <SortChipControls
      sortables={sortables}
      sortableDefinitions={sortableDefinitions}
      dropdownOpenIndexes={dropdownOpenIndexes}
      setDropdownOpenIndexes={setDropdownOpenIndexes}
      onRemoveSortable={(index) => {
        const newSortables = [...sortables];
        newSortables.splice(index, 1);
        if (newSortables.length === 0) {
          setIsOpen(false);
        }
        setSortables(newSortables);
      }}
    />
  );
}
